// extracted by mini-css-extract-plugin
export var chevronIcon = "_cp-2";
export var teamName = "_cp-1";
export var teamSwitcherButton = "_cp-0";